const state= {
    Items:{
        data:[],
        total:0
    },
};

const getters = {
    Items : (state) => state.Items,
};

const actions = {
    getItems({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/chart-of-account`,{
                params: params
            })
                .then(response => {
                    commit( 'setItems', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => {
                    reject( error )
                });
        });
    },
    createItem({commit},param){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/chart-of-account`,param)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => {
                    reject( error )
                });
        });
    },
    updateItem({commit},param){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/chart-of-account/${param.id}`,param)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => {
                    reject( error )
                });
        });
    },
    deleteItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/chart-of-account`, {
                data:{
                    ids:params
                }
            })
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    importItems({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('import',params.fileImport);
            global.axios.post(`api/chart-of-account/import`,formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve( response );
                })
                .catch(error =>{
                    reject( error )
                } );
        });
    },
    getCompanies({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/chart-of-account/company`,{
                params: params
            })
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => {
                    reject( error )
                });
        });
    },
};

const mutations = {
    setItems (state,data) {
        state.Items.data = data.items;
        state.Items.total = data.total;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}